module.exports = __webpack_public_path__ + "static/media/sashimi.74531086.jpg";